import { Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { endpoint } from 'views/pages/manage/common/constant';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { ReactComponent as RighArrow } from "assets/img/svg/fi_chevron-right.svg"
import "./style.scss";
import moment from 'moment';
import { ReactComponent as InfoIcon } from "assets/img/svg/InfoGrayIcon.svg"
import { SUCCESS } from 'dropzone';

export const advancePaymentList = [
    { key: 'lumpsum', value: 'Lump sum', notApplicable: 'N/A' },
    { key: 'loanDetails', value: 'Loans' },
    { key: 'tribyte', value: 'Tribyte Access' },
    { key: 'jodo', value: 'Jodo' },
    { key: 'van', value: 'Van A/C' },
    { key: 'salesforce', value: 'Salesforce' },
]

export const advancedPaymentValue = (item, advancePaymentDetail, currentApplicationDetails, handleDialog) => {
    const { psid, applicationId, businessAreaDispValue } = currentApplicationDetails
    if (advancePaymentDetail?.[item?.key]) {
        console.log(advancePaymentDetail?.[item?.key]?.status)
        if (advancePaymentDetail?.[item?.key]?.status == 'ACTIVE') {
            if (item?.key == 'loanDetails') {
                return (advancePaymentDetail?.[item?.key]?.loanInternalDetails).map(e => <div
                    className='chip-style'
                    onClick={() => {
                        const url = `${window.location.origin
                            }/#/admin/doDetails/?applicationId=${applicationId}&applicationQuotationDetailsId=${e?.quotationId}&isOldQuotation=${e?.new ? 'new' : 'old'}&businessAreasDisplay=${businessAreaDispValue}&psid=${psid}&readOnly=true`;
                        // Open the new tab with the constructed URL
                        window.open(url, "_blank").focus();
                    }}
                >
                    <span>{e?.title}</span> <span><RighArrow /></span>
                </div>)
            }
            else if (item?.key == 'salesforce') {
                return <div className='chip-style' onClick={() => handleDialog(item)}><span>View details</span> <span><RighArrow /></span></div>
            }
            else
                return <div style={statusStyle.ACTIVE}>Active</div>
        }

        else if (advancePaymentDetail?.[item?.key]?.status == 'INACTIVE')
            return <div style={statusStyle.INACTIVE}>Inactive</div>
        else if (advancePaymentDetail?.[item?.key]?.status == 'REACTIVE')
            return <div style={statusStyle.REACTIVE}>Reactive</div>
        else
            return <div style={statusStyle.NA}>N/A</div>
    }

}

export const statusStyle = {

    ACTIVE: {
        backgroundColor: "#BBE2CE",
        color: "#0B442D",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
    NA: {
        backgroundColor: "#F5F5F5",
        color: "#262626",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
    INACTIVE: {
        backgroundColor: "#F9D9D7",
        color: "#0B442D",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
    REACTIVE: {
        backgroundColor: "#f59342",
        color: "#0B442D",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    }
};
export const rowStyle = { display: "grid", gridTemplateColumns: "200px auto", justifyContent: "start" };
const serviceSyncCodeMapping = {
    A: 'Activate',
    D: 'Deactivate',
    R: 'Reactivate',
    C: 'Create',
    ACTIVATE: 'Activate',
    DEACTIVATE: 'Deactivate',
    REACTIVATE: 'Reactivate',
    CREATE: 'Create',
}
export const paymentModeEyeIcon = ["tribyte", "van", "jodo", "lumpsum"]
const tribyteStatusMapping = {
    D: 'Done',
    E: 'Error',
    SUCCESS: 'Done',
    ERROR: 'Error'
}
const tribyteStatusStyleMapping = {
    D: {
        backgroundColor: "#BBE2CE",
        color: "#0B442D",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
    E: {
        backgroundColor: "#F9D9D7",
        color: "#B32306",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
    SUCCESS: {
        backgroundColor: "#BBE2CE",
        color: "#0B442D",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
    ERROR: {
        backgroundColor: "#F9D9D7",
        color: "#B32306",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
}

export const tooltipDescMapping = {
    "Salesforce account ID": "This is same as  PS ID.",
    "Salesforce opportunity ID": "This is same as Application ID.",
    "Salesforce account ID": "This is same as  PS ID.",
    "Salesforce opportunity ID": "This is same as Application ID.",
    "Salesforce receipt ID": "Registration Fee Receipt – Opportunity Closed Won"
}

export const paymentModeCOlumn = {
    tribyte: (props) => {
        return [
            new AGridColDef("id", "Seq No.", false)
                .setMinWidth(30)
                .editable(true)
                .setFlex(0.20)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("operationType", "Service Sync", false)
                .setMinWidth(30)
                .editable(true)
                .setFlex(0.20)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={serviceSyncCodeMapping?.[params?.value]}>
                        <div className={`ellipsis-text-container`}>{serviceSyncCodeMapping?.[params?.value]}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("transactionDate", "Transaction Date", false)
                .setMinWidth(45)
                .editable(true)
                .setFlex(0.30)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={moment(params?.value).format("DD/MM/YYYY")}>
                        <div className={`ellipsis-text-container`}>{moment(params?.value).format("DD/MM/YYYY")}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("updatedOn", "Last Updated Date/Time", false)
                .setMinWidth(80)
                .editable(true)
                .setFlex(0.50)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={`${moment(params?.value).format('DD/MM/YYYY')} ${moment(params?.value).format('hh:mm A')}`}>
                        <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD/MM/YYYY')} {moment(params?.value).format('hh:mm A')}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("syncStatus", "Status", false)
                .setMinWidth(30)
                .editable(true)
                .setFlex(0.20)
                .renderCellComponent((params) => (
                    params?.value ?
                        <div className={`ellipsis-text-container`} style={tribyteStatusStyleMapping?.[params?.value]} >{tribyteStatusMapping?.[params?.value]}</div>
                        : <div>-</div>
                )),

        ]
    },
    van: (props) => {
        return [
            new AGridColDef("id", "VAN Nbr.", false)
                .setMinWidth(40)
                .editable(true)
                .setFlex(0.30)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("merchantPrefix", "Name", false)
                .setMinWidth(50)
                .editable(true)
                .setFlex(0.30)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("vanAccount", "Bank Acc", false)
                .setMinWidth(90)
                .editable(true)
                .setFlex(0.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("vanBankName", "Bank Name", false)
                .setMinWidth(80)
                .editable(true)
                .setFlex(0.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("ifscCode", "IFSC Code", false)
                .setMinWidth(60)
                .editable(true)
                .setFlex(0.30)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("updatedOn", "Date", false)
                .setMinWidth(70)
                .editable(true)
                .setFlex(0.4)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={moment(params?.value).format('DD/MM/YYYY')}>
                        <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD/MM/YYYY')}</div>
                    </Tooltip> : <div>-</div>
                )),

        ]
    },
    salesforce: (handleClick) => {
        return [
            new AGridColDef("type", "Type", false)
                .setMinWidth(110)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div className='d-flex align-items-center cursor' style={{ gap: '7px', width:'100%' }}><Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`} style={{ width: '90%' }} >{params?.value}</div>
                    </Tooltip>
                        <InfoIcon onClick={(e) => { handleClick(e, params?.row) }} />
                    </div> : <div>-</div>
                )),
            new AGridColDef("id", "ID", false)
                .setMinWidth(100)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("createdOn", "Creation Date Time", false)
                .setMinWidth(100)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={`${convertToUtcAndIst(params?.value).format('DD/MM/YYYY')} at ${convertToUtcAndIst(params?.value).format("hh:mm A")}`}>
                        <div className={`ellipsis-text-container`}>{`${convertToUtcAndIst(params?.value).format('DD/MM/YYYY')} at ${convertToUtcAndIst(params?.value).format("hh:mm A")}`}</div>
                    </Tooltip> : <div>-</div>
                )),
            new AGridColDef("ownerId", "Owner", false)
                .setMinWidth(80)
                .editable(true)
                .setFlex(0.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                )),

        ]
    }
}

export const convertToUtcAndIst = (utcTime) => {
    const utcMoment = moment.utc(utcTime, "YYYY-MM-DD HH:mm:ss.S");
    const ist = utcMoment.clone().add(5, 'hours').add(30, 'minutes');
    return ist;
}